<template>
  <span>
    <template v-if="symbol === 'g'">
      {{ Number(quantityGr) | number-format(2,true) }} {{ $tc('label.gram', Number(quantityGr)) }}
    </template>
    <template v-else>
      {{ amount | number-format }} {{ servingSizeTitle }} ({{ Number(quantityGr) | number-format(2,true) }}g)
    </template>
  </span>
</template>

<script>
export default {
  name: 'nuttrema-stuff-to-eat-quantity',
  props: {
    amount: {
      required: true,
      default: null,
    },
    servingSizeTitle: {
      required: true,
      default: null,
    },
    quantityGr: {
      required: true,
      default: null,
    },
    symbol: {
      required: true,
      default: null,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/label/nuttrema-stuff-to-eat-quantity.vue